import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { clearCsrfToken } from '../../api/csrf';
import { useLogout } from '../../auth/authQueries';
import { Brand, CenteredCardLayout } from '../../components/layout/CenteredCardLayout';
import { Button, pushToast } from '../../components/ui';
import { ROUTES } from '../../lib/routes';
import { track } from '../../lib/logger';

/** Logout confirmation page (spec §6): never logs out via a bare GET. */
export default function LogoutPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const logout = useLogout();

  function handleConfirm(): void {
    track('auth_logout_started', { route: ROUTES.logout });
    logout.mutate(undefined, {
      onSuccess: () => {
        clearCsrfToken();
        queryClient.clear();
        navigate(ROUTES.login, { replace: true });
      },
      onError: () => pushToast('Không thể đăng xuất. Vui lòng thử lại.', 'error'),
    });
  }

  return (
    <CenteredCardLayout>
      <div className="stack">
        <Brand />
        <header>
          <h1>Đăng xuất?</h1>
          <p className="muted">Bạn có chắc muốn đăng xuất khỏi thiết bị này?</p>
        </header>
        <div className="stack">
          <Button variant="danger" fullWidth onClick={handleConfirm} loading={logout.isPending}>
            Đăng xuất
          </Button>
          <Button variant="secondary" fullWidth onClick={() => navigate(ROUTES.account)}>
            Hủy
          </Button>
        </div>
      </div>
    </CenteredCardLayout>
  );
}
